export default __webpack_public_path__ + "static/media/gamefi_03_2.90b2f06f.png";